import React from 'react'
import * as S from './Paginator.styled'
import * as Theme from '@styles/theme-const'
import Button from '../Button/Button'
import ArrowLeft from '../../Icons/ArrowLeft'
import ArrowRight from '../../Icons/ArrowRight'
import ThreeDots from '../../Icons/ThreeDots'
import { useCurrentPage, useOnSelectedPage, usePageCount } from 'src/widgets/pagination-goods/model'
import { ThemeColors } from 'src/shared/ui/consts-styles'

const navType = {
    default: 1,
    separator: 2,
    left: 3,
    right: 4
}
const colorsButtonDefault = {
    color: Theme.ColorConsts.getGrayColor(0.6),
    backgroundColor: 'inherit',
    hoverBackgroundColor: ThemeColors.gray5
}
const colorsButtonSelect = {
    color: ThemeColors.white,
    backgroundColor: ThemeColors.accentGreen,
    hoverBackgroundColor: ThemeColors.accentGreenLight
}

const Paginator = () => {
    const pageCount = usePageCount()
    const currentPage = useCurrentPage()
    const onSelectedPage = useOnSelectedPage()
    if (pageCount <= 1) return <React.Fragment />
    const selectHandler = (type, value) => () => {
        if (type === navType.left && currentPage > 1) {
            onSelectedPage(currentPage - 1)
            return
        }
        if (type === navType.right && currentPage < pageCount) {
            onSelectedPage(currentPage + 1)
            return
        }
        if (type === navType.default) {
            onSelectedPage(value)
        }
    }
    const getPageButtons = () => {
        let pageButtons = []
        const limitLastPages = pageCount - Theme.PagintaionMaxCount + 3

        pageButtons.push({
            type: navType.left,
            key: 'left',
            value: <ArrowLeft />,
            colors: colorsButtonDefault,
            selectHandler: selectHandler(navType.left),
            isClickable: true
        })

        const separatorButton = {
            type: navType.separator,
            key: 'separator',
            value: <ThreeDots />,
            colors: colorsButtonDefault,
            selectHandler: selectHandler(navType.separator),
            isClickable: false
        }
        {
            /* Если количество страниц меньше чем максимальное количество кнопок в пагинаторе*/
        }
        if (pageCount < Theme.PagintaionMaxCount) {
            for (let pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
                pageButtons.push({
                    type: navType.default,
                    key: pageNumber,
                    value: pageNumber,
                    colors: currentPage === pageNumber ? colorsButtonSelect : colorsButtonDefault,
                    selectHandler: selectHandler(navType.default, pageNumber),
                    isClickable: true
                })
            }
        } else if (pageCount >= Theme.PagintaionMaxCount && currentPage < Theme.PagintaionMaxCount - 2) {
            {
                /* Если выбранная страница в начале */
            }
            for (let pageNumber = 1; pageNumber <= Theme.PagintaionMaxCount - 2; pageNumber++) {
                pageButtons.push({
                    type: navType.default,
                    key: pageNumber,
                    value: pageNumber,
                    colors: currentPage === pageNumber ? colorsButtonSelect : colorsButtonDefault,
                    selectHandler: selectHandler(navType.default, pageNumber),
                    isClickable: true
                })
            }
            pageButtons.push(separatorButton)
            pageButtons.push({
                type: navType.default,
                key: pageCount,
                value: pageCount,
                colors: colorsButtonDefault,
                selectHandler: selectHandler(navType.default, pageCount),
                isClickable: true
            })
        } else if (pageCount >= Theme.PagintaionMaxCount && currentPage > limitLastPages) {
            {
                /* Если выбранная страница в конце */
            }
            pageButtons.push({
                type: navType.default,
                key: 1,
                value: 1,
                colors: colorsButtonDefault,
                selectHandler: selectHandler(navType.default, 1),
                isClickable: true
            })
            pageButtons.push(separatorButton)

            for (let pageNumber = limitLastPages; pageNumber <= pageCount; pageNumber++) {
                pageButtons.push({
                    type: navType.default,
                    key: pageNumber,
                    value: pageNumber,
                    colors: currentPage === pageNumber ? colorsButtonSelect : colorsButtonDefault,
                    selectHandler: selectHandler(navType.default, pageNumber),
                    isClickable: true
                })
            }
        } else if (pageCount > Theme.PagintaionMaxCount && currentPage <= limitLastPages) {
            {
                /* Если выбранная страница в середине */
            }
            pageButtons.push({
                type: navType.default,
                key: 1,
                value: 1,
                colors: colorsButtonDefault,
                selectHandler: selectHandler(navType.default, 1),
                isClickable: true
            })
            pageButtons.push(separatorButton)
            pageButtons.push({
                type: navType.default,
                key: currentPage - 1,
                value: currentPage - 1,
                colors: colorsButtonDefault,
                selectHandler: selectHandler(navType.default, currentPage - 1),
                isClickable: true
            })
            pageButtons.push({
                type: navType.default,
                key: currentPage,
                value: currentPage,
                colors: colorsButtonSelect,
                selectHandler: selectHandler(navType.default, currentPage),
                isClickable: true
            })
            pageButtons.push({
                type: navType.default,
                key: currentPage + 1,
                value: currentPage + 1,
                colors: colorsButtonDefault,
                selectHandler: selectHandler(navType.default, currentPage + 1),
                isClickable: true
            })
            {
                /* Это нужно для уникальности компонентов */
            }
            let separator2 = { ...separatorButton, key: 'separator2' }

            pageButtons.push(separator2)
            pageButtons.push({
                type: navType.default,
                key: pageCount,
                value: pageCount,
                colors: colorsButtonDefault,
                selectHandler: selectHandler(navType.default, pageCount),
                isClickable: true
            })
        }
        pageButtons.push({
            type: navType.right,
            key: 'right',
            value: <ArrowRight />,
            colors: colorsButtonDefault,
            selectHandler: selectHandler(navType.right),
            isClickable: true
        })
        return pageButtons
    }

    if (pageCount <= 1) return <S.Container></S.Container>
    return (
        <S.Container>
            {getPageButtons().map((x) => (
                <Button
                    key={x.key}
                    elementSizeTypeValue={Theme.ElementSizeType.superSmall}
                    colors={x.colors}
                    isClickable={x.isClickable}
                    clickHandler={x.selectHandler}>
                    {x.value}
                </Button>
            ))}
        </S.Container>
    )
}

export default Paginator
